import { gql } from "@apollo/client";

export const GET_DAMAGE_MATRIX = gql`
  query damageMatrix($id: String!) {
    damageMatrix(id: $id) {
      id
      type
      tenantId
      organisationId
      branchId
      make
      model
      year
      components{
        part
        damageType
        s1
        s2
        s3
        s4
        vatOnSMR
        vatOnParts
        vatOnInstallation
        replacementCost
        installationCharges
        overallMarkup
      }
      createdAt
      updatedAt
      updatedBy {
        id
        firstName
        lastName
        role
      }
    }
  }
`;
